var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToggleLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.8,2h-25c-8.4,0-15.2,6.8-15.2,15.2v.2c0,8.4,6.8,15.2,15.2,15.2h25c8.4,0,15.2-6.8,15.2-15.2v-.2c0-8.4-6.8-15.2-15.2-15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.5,23.2c3.5,0,6.2-2.8,6.2-6.2s-2.8-6.2-6.2-6.2-6.2,2.8-6.2,6.2,2.8,6.2,6.2,6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,20.3c.9,0,1.7-.3,2.3-1,.6-.6,1-1.4,1-2.3s-.3-1.7-1-2.3c-.6-.6-1.4-1-2.3-1s-1.7.3-2.3,1c-.6.6-1,1.4-1,2.3s.3,1.7,1,2.3c.6.6,1.4,1,2.3,1ZM12,22.5c-1.5,0-2.8-.5-3.9-1.6-1.1-1.1-1.6-2.4-1.6-3.9s.5-2.8,1.6-3.9c1.1-1.1,2.3-1.6,3.9-1.6s2.8.5,3.9,1.6c1.1,1.1,1.6,2.4,1.6,3.9s-.5,2.8-1.6,3.9-2.4,1.6-3.9,1.6ZM4.4,18.1H0v-2.2h4.4v2.2ZM24,18.1h-4.4v-2.2h4.4v2.2ZM10.9,9.4v-4.4h2.2v4.4h-2.2ZM10.9,29v-4.4h2.2v4.4h-2.2ZM5.9,12.4l-2.8-2.6,1.6-1.6,2.6,2.7s-1.4,1.5-1.4,1.5ZM19.3,25.9l-2.6-2.8,1.4-1.5,2.8,2.6-1.6,1.6h0ZM16.6,10.9l2.6-2.8,1.6,1.6-2.7,2.6-1.5-1.4ZM3.1,24.3l2.8-2.6,1.5,1.4-2.6,2.8-1.6-1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106,26c-2.5,0-4.6-.9-6.4-2.6s-2.6-3.9-2.6-6.4.9-4.6,2.6-6.4,3.9-2.6,6.4-2.6.5,0,.7,0h.7c-.7.5-1.2,1.1-1.6,1.9-.4.8-.6,1.6-.6,2.5,0,1.5.5,2.8,1.6,3.8,1,1,2.3,1.6,3.8,1.6s1.8-.2,2.5-.6,1.4-1,1.9-1.6v1.4c0,2.5-.9,4.6-2.6,6.4s-3.9,2.6-6.4,2.6ZM106,24c1.5,0,2.8-.4,3.9-1.2s2-1.9,2.6-3.2c-.3,0-.7.1-1,.2h-1c-2.1,0-3.8-.7-5.2-2.2-1.4-1.4-2.2-3.2-2.2-5.2s0-.7,0-1,0-.7.2-1c-1.3.5-2.4,1.4-3.2,2.6-.8,1.2-1.2,2.5-1.2,3.9s.7,3.6,2.1,5,3,2,4.9,2h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleLightMode);
export default __webpack_public_path__ + "static/media/icon-toggle-light-mode.07401f433c9d66d8832f9439f2ab4a34.svg";
export { ForwardRef as ReactComponent };